
import { from, iif, Observable, empty as observableEmpty, of, throwError } from 'rxjs';

import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import "rxjs/add/operator/finally";
import { catchError, concatMap, delay, finalize, map, mergeMap, retryWhen, switchMap } from 'rxjs/operators';
import * as moment from "moment";
import { constant, MsgConfig } from "..";
import { environment } from "../../environments/environment";
import { CommonStore } from '../store';
import { AlertService } from "./alert.service";
import { CommonService } from "./common.service";
import { LoaderService } from "./loader.service";
import { UserService } from "./user.service";
import { Location } from "@angular/common";
import { CommonUtil } from '../utils';
import { HubService } from './Hub.service';
import { InterfaceUtils } from '../utils/interface.util';
import { Router } from '@angular/router';
import { appState } from '../store/appstate';
const baseUrl = environment.baseUrl;
const i18nUrl = environment.baseUrlTranslations;
const interfaceHubUrl = environment.interfaceHubUrl;
const reportWriterUrl = environment.reportWriterbaseUrl;
const formsUrl = environment.formsbaseUrl;
const vaccineurl = environment.vaccinebaseurl;
const documentsUrl = environment.documentBaseurl;
const primecommproxyBaseUrl = environment.primecommproxy_BaseUrl;
const primecommBaseUrl = environment.primecomm_BaseUrl;
const retryErrorStatuList:number[] = [500, 501, 502, 503, 504 ];
const retryUnauthorizedError:number[] = [401, 403];
const priorAuthUrl = (environment as any)?.priorAuthBaseUrl || '';
const prescriptionBaseUrl = (environment as any)?.prescriptionBaseUrl || '';
const ivrBaseUrl = (environment as any)?.ivrBaseUrl || '';
const pdmpVendorBaseUrl = (environment as any)?.pdmpVendorBaseUrl || '';
declare const DD_RUM: any;

@Injectable()
export class BaseHttpInterceptor implements HttpInterceptor {
    private totalRequests = 0;
    endTime :number;
    interfaceToken: any;
    override:boolean = false;
    clearCookiesCalled: any;
    _interfaceUtil = inject(InterfaceUtils);
    currentUserId:any;
    private _cmnUtil = inject(CommonUtil);
    constructor(
        private _userServ: UserService,
        private _loadrServ: LoaderService,
        private _commonSer: CommonService,
        private _alertServ: AlertService,
        private _cmnStr: CommonStore,
        private _location: Location,
        private _hubService : HubService,
        private _router: Router,
    ) {
        this._commonSer.systemSettings$.subscribe(resp => {
            if (resp) {
                this.endTime = this._commonSer.getSetttingValue(
                    "PharmacySettings",
                    "IN_ACTIVITY_TIMEOUT"
                );
                // this.endTime = 1;
            }
        });
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const stopAddingDefURL = req.headers.get("stopAddingDefURL") === "true";
        const isWebPubSubURL = req.headers.get("WebPubSubURL") === "true";
        const doNotDefBaseUrl = req.headers.get("doNotDefBaseUrl") === "true";
        const logicoy = req.headers.get("logicoyToken");
        const authorizeInterfaceToken = sessionStorage.getItem("InterfaceToken") ? this._commonSer.DecryptData(sessionStorage.getItem("InterfaceToken")) : "";
        const authorizeSSOToken = sessionStorage.getItem("ssoToken");
        const frRprttWriterBaseUrl = req.headers.get("frRprttWriterBaseUrl") === "true";
        // const access_token = this._userServ.getAccessToken();
        const formBaseUrl = req.headers.get("formsBaseUrl") === "true";
        const frDocumnetBaseUrl = req.headers.get("frDocumnetBaseUrl") === "true";
        const frImmunizationBaseUrl = req.headers.get("frImmunizationBaseUrl") === "true";
        const isSPCBaseUrl = req.headers.get("isSPCBaseUrl") === "true";
        const isSPCNoProxyBaseUrl = req.headers.get("isSPCNoProxyBaseUrl") === "true";
        const microSvcUrlToken = this._cmnUtil.getCommonMicroSvcToken();
        const frpriorAuthBaseUrl = req.headers.get("frpriorAuthBaseUrl") === "true";
        const frprescriptionBaseUrl = req.headers.get("frprescriptionBaseUrl") === "true";
        const frimunizationbaseurl = req.headers.get("frimunizationbaseurl") === "true";
        const isSSORequest = req.headers.get("isSSORequest") === "true";
        const access_token = this.checkAndGetToken2(req);
        const frivrBaseUrl = req.headers.get("frivrBaseUrl") === "true";
        const isRetryNeeded = req.headers.get("isRetryNeeded") === "true";
        const authTokenNeeded = req.headers.get("authTokenNeeded") === "true";
        const isDocumentBaseUrl = req.headers.get("docBaseUrl") === "true";
        const frPDMPBaseUrl = req.headers.get("frPDMPBaseUrl") === "true";

        let showLoader = true;
        if (this.checkAndSetTimeout(req.url)) {
            showLoader = false; 
        }
        
        const needsAuthToken = (frRprttWriterBaseUrl || formBaseUrl || frImmunizationBaseUrl || frDocumnetBaseUrl || isDocumentBaseUrl ||
            isSPCBaseUrl || isSPCNoProxyBaseUrl || isWebPubSubURL || frpriorAuthBaseUrl || frprescriptionBaseUrl || frivrBaseUrl || authTokenNeeded || frPDMPBaseUrl);

        let authToken = "";
        if (logicoy) {
            authToken = "Basic " + logicoy;
        } else if (authorizeInterfaceToken && doNotDefBaseUrl) {
            authToken = "Bearer " + authorizeInterfaceToken;
        } else if (microSvcUrlToken && needsAuthToken) {
            authToken = "Bearer " + microSvcUrlToken;
        } else if (access_token && !isSSORequest) {
            authToken = "Bearer " + access_token;
        } else if (authorizeSSOToken && isSSORequest) {
            authToken = atob(authorizeSSOToken);
        }

        let newUrl = req.url;
        if (req.url.indexOf("assets/i18n") > 0) {
            newUrl = i18nUrl + req.url;
        } else if (isSPCBaseUrl) {
            newUrl = primecommproxyBaseUrl + req.url;
        } else if (isSPCNoProxyBaseUrl) {
            newUrl = primecommBaseUrl + req.url;
        } else if (isWebPubSubURL) {
            newUrl = req.url;
        } else if (frImmunizationBaseUrl) {
            newUrl = vaccineurl + req.url;
        } else if (frDocumnetBaseUrl) {
            newUrl = documentsUrl + req.url;
        } else if (frRprttWriterBaseUrl) {
            newUrl = reportWriterUrl + req.url;
        } else if (formBaseUrl) {
            newUrl = formsUrl + req.url;
        } else if (frpriorAuthBaseUrl) {
            newUrl = priorAuthUrl + req.url;
        } else if (frprescriptionBaseUrl) {
            newUrl = prescriptionBaseUrl + req.url;
        } else if (frivrBaseUrl) {
            newUrl = ivrBaseUrl + req.url;
        } else if (doNotDefBaseUrl) {
            newUrl = interfaceHubUrl + req.url;
        } else if (frPDMPBaseUrl) {
            newUrl = pdmpVendorBaseUrl + req.url;
        } else if (isDocumentBaseUrl) {
        newUrl = documentsUrl + req.url;
        } else if (!stopAddingDefURL) {
            if (!(req.url.includes("chart") || req.url.includes("logicoy"))) {
                newUrl = baseUrl + req.url;
            }
        }

        let headers = req.headers;
        if(!logicoy){
            headers = headers.set("TimeZoneOffset", new Date().getTimezoneOffset().toString())
            headers = headers.set("TenantNPI", this._userServ.getToken("UniquePharmacyId"))
            headers = headers.set("TenantId", this._userServ.getToken("TenantId"))
            headers = headers.set("PharmacistId", this.checkAndGetPharmacistid(req))
            headers = headers.set("TechnicianId", this.checkAndGetTechnicianid(req))
            headers = headers.set("UserId",this.checkAndGetUserid(req))
            headers = headers.set("AuthOtoken", frimunizationbaseurl ? microSvcUrlToken : '')
            headers = headers.set("Ocp-Apim-Trace",'true')
            headers = headers.set("Ocp-Apim-Trace-Location",'true')
        }
        if (logicoy) {
            headers = headers.delete("logicoyToken");
            headers = headers.delete("authTokenNeeded");
        }

        let clonedReq: HttpRequest<any>;

        if (needsAuthToken || this.override || doNotDefBaseUrl || isSSORequest) {
            if (isSSORequest)
            {
              clonedReq = req.clone({
                url: newUrl,
                headers: headers.set("Authorization", authToken),
                withCredentials: true
              });
            }
            else{
                clonedReq = req.clone({
                    url: newUrl,
                    headers: headers.set("Authorization", authToken)
                });
            }
        }
       else {
            clonedReq = req.clone({
                url: newUrl,
                headers,
                withCredentials: true
            });
        }

        const isLoadNotReq = clonedReq.headers.get("isLoadNotReq");
        const loaderMsg = clonedReq.headers.get("loadingMesssage");
        if (isLoadNotReq !== "true" && showLoader) {
            this.totalRequests++;
            this.startLoader();
        }

        if (loaderMsg) {
            this.showLoaderMsg(loaderMsg);
        }
        if(req?.url?.includes('/login') || req?.url?.toLowerCase()?.includes('sso') || req?.url?.includes('assets') || req?.url?.includes('ValidateSession') ) {
            if(req.url.includes('/login') || req?.url?.toLowerCase()?.includes('sso')) {
                appState.isSessionValid = true;
            }
            return this.handleApiNext(next, clonedReq, req, isLoadNotReq, loaderMsg, isRetryNeeded);
        }

        return this._userServ.validateSession().pipe(
            concatMap((res)=>iif(()=>res===false, 
            of(res).pipe(map(isValid=> {
               this.clearCookies();
            })), 
            this.handleApiNext(next, clonedReq, req, isLoadNotReq, loaderMsg, isRetryNeeded)))
        )
        
    }

    handleApiNext(next, clonedReq, req, isLoadNotReq, loaderMsg, isRetryNeeded) {
        const  delayMs = 500;
        const maxRetries = 2;
        let retryCount = 0;
         return next.handle(clonedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                // ================== DATADOG AUTH DEBUG (TEMPORARY) ==================
try {
  if (error.status === 401 && typeof DD_RUM !== 'undefined') {

    const headersObj: Record<string, string | null> = {};
    clonedReq.headers.keys().forEach(key => {
      headersObj[key] = clonedReq.headers.get(key);
    });

    DD_RUM.addAction('Token Checking', {
      url: clonedReq.url,
      method: clonedReq.method,

      // Cookie behaviour
      withCredentials: clonedReq.withCredentials === true,
      sameOrigin: clonedReq.url.startsWith(window.location.origin),

      // Header visibility (Authorization value will be REDACTED)
      headers: headersObj,

      // Extra context (helps in prod)
      hasAuthorizationHeader: clonedReq.headers.has('Authorization'),
      authorizationHeaderLength:
        clonedReq.headers.get('Authorization')?.length || 0
    });
  }
} catch (e) {
  // Never break interceptor
}
// ================== END DATADOG DEBUG ==================

                const isUnauthorized =
                    retryUnauthorizedError?.includes(error.status) &&
                    !error?.url?.includes(baseUrl);

                const isRetryableStatus =
                    retryErrorStatuList?.includes(error?.status) &&
                    !error?.error?.EventKey;
                // const isRetryableUrl = clonedReq?.url?.includes("web-app") || clonedReq?.url?.includes("web");
                var isMethodAllowed = clonedReq.method === 'GET' || (clonedReq.method === 'POST' && isRetryNeeded);
                // 🔁 Retry auth errors
                if (isUnauthorized) {
                    return from(this._commonSer.getCmnAuthToken().toPromise()).pipe(
                        switchMap((resp: any) => {
                            if (resp?.AccessToken) {
                                sessionStorage.setItem("CmnMicroSvcToken", this._commonSer.encryptData(resp.AccessToken));

                                const newReq = clonedReq.clone({
                                    headers: clonedReq.headers
                                        .delete("Authorization")
                                        .set("Authorization", `Bearer ${resp.AccessToken}`)
                                });

                                return next.handle(newReq);
                            }

                            return throwError(() => error);
                        })
                    );
                }

                // 🔁 Retry server errors (e.g., 500, 502, etc.) with delay
                if (
                    retryCount < maxRetries &&
                    isRetryableStatus &&
                    isMethodAllowed
                ) {
                    retryCount++;
                    return of(error).pipe(delay(delayMs), switchMap(() => next.handle(clonedReq)));
                }
                if (error.status === 403 && (error?.url?.includes('User/LicenseKeys') || error?.url?.includes('Settings/SystemSettings'))) {
                    return throwError(error);
                }
                else {
                    return throwError(() => error);
                }
            }),

            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body?.EventKey) {
                        this._alertServ.warning(event.body.EventKey);
                    } else if (event.body?.ErrorMessage) {
                        this._alertServ.warning(event.body.ErrorMessage);
                    } else if (event.body?.[0]?.ErrorMessage) {
                        this._alertServ.warning(event.body[0].ErrorMessage);
                    }

                    if (event.url.includes("Reports/AsyncReports")) {
                        this.hideLoader();
                    }
                }
                return event;
            }),

            catchError((event: HttpErrorResponse) => {
                if (event.error instanceof Blob) {
                    const reader = new FileReader();
                    reader.onload = (readResult: Event) => {
                        const errmsg = JSON.parse((<any>readResult.target).result);
                        this._alertServ.error(errmsg.Message);
                    };
                    reader.readAsText(event.error);
                } else if (event.error?.EventKey && event.error?.Message) {
                    this._alertServ.error(event.error.Message);
                } else if (event.status === 403 && (event?.url?.includes('User/LicenseKeys') || event?.url?.includes('Settings/SystemSettings'))) {
                    if (event?.url?.includes('User/LicenseKeys')) {
                        return throwError(event);
                    } else {
                        this.currentUserId = this._userServ.getToken("UserId");
                        this.logout();
                    }
                }
                else if (event.status === 401) {
                    if (!this._userServ.getAccessToken()) {
                        this._userServ._sessionTimeout$.next("Timeout");
                    } else {
                        this._alertServ.error("Unauthorized Access.");
                    }
                } else if (event.url?.includes('logicoy')) {
                    const logicoyLink = event.error?.Report?.ReportRequestURLs?.ViewableReport?.Value;
                    if (logicoyLink) window.open(logicoyLink, "_blank");
                }


                if (event && !event.error && typeof event === 'function') {
                    const errorResponse = (event as any)();
                    if (errorResponse?.error?.Message && MsgConfig.API_LIST_TO_SHOW_SERVER_ERROR.includes(req.url)) {
                        this._alertServ.error(errorResponse.error.Message);
                    }
                }

                return observableEmpty();
            }),

            finalize(() => {
                if (isLoadNotReq !== "true") {
                    this.decreaseRequests();
                }
                if (loaderMsg) {
                    this.removeLoaderMsg();
                }
            })
        );
    }
    logout() {
        sessionStorage.setItem("TimeOutPopOpened", this._commonSer.encryptData("true"));
        this._loadrServ.display(false);
        this._hubService.RemoveFromGroup();
        if (this.currentUserId) {
            this._cmnStr.isTimeOutSession(true);
                this.closeSessionTimeOutPopup();
        }
    }
    closeSessionTimeOutPopup(){
        this._cmnStr.isTimeOutSession(null);
        sessionStorage.removeItem("TimeOutPopOpened");
        this.clearCookies(true);
    }
    private isSafeRedirectUrl(url: string): boolean {
        if (!url || typeof url !== "string") return false;
        const trimmed = url.trim();
        if (/^(javascript:|data:|vbscript:|mailto:)/i.test(trimmed)) {
            return false;
        }
        try {
            const parsed = new URL(trimmed, window.location.origin);
            if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
                return false;
            }
            if (parsed.origin !== window.location.origin) {
                return false;
            }
            return true;
        } catch {
            return false;
        }
    }

    clearCookies(timeExpired?: boolean) {
        if(this.clearCookiesCalled) {
            return;
        }
        this.clearCookiesCalled = true;
        const res = document.cookie;
        const multiple = res.split(";");
        for (let i = 0; i < multiple.length; i++) {
            const key = multiple[i].split("=");
            document.cookie =
                "" +
                key[0] +
                "=; expires= Thu, 21 Aug 1970 20:00:00 UTC; path=/ ";
        }
        let SfaxEncryptionVector = this._commonSer.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        let printSet = localStorage.getItem("DefaultLabelPrinter");
        let reportPrint = localStorage.getItem("DefaultReportPrinter");
        let IsImmediateModeKey = localStorage.getItem("ImmediateOrPopMode") ? this._commonSer.getDecryptLocalStorage("ImmediateOrPopMode", false, SfaxEncryptionVector): null;
        let guidKey = localStorage.getItem("GUIDEyecon") ? this._commonSer.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector):null;
        let EyeconIP = localStorage.getItem("EyeconIP") ? this._commonSer.getDecryptLocalStorage("EyeconIP", false, SfaxEncryptionVector):null;
        let popModeAssigned = localStorage.getItem("popModeAssigned") ? this._commonSer.getDecryptLocalStorage("popModeAssigned",false,SfaxEncryptionVector): null;
        let sso = this._commonSer.DecryptData(localStorage.getItem("SSO"));
        let redirectUrl = localStorage.getItem("redirectUrl");
        let ivrGuid = this._commonSer.getIvrGUIDDetails(SfaxEncryptionVector);
        localStorage.clear();
        if (printSet) {
            localStorage.setItem("DefaultLabelPrinter", printSet);
        }
        if (reportPrint) {
            localStorage.setItem("DefaultReportPrinter", reportPrint);
        }
        this._interfaceUtil.setPillCounterLocalStorage(SfaxEncryptionVector, IsImmediateModeKey, guidKey, EyeconIP, popModeAssigned);
        if(ivrGuid) {
            localStorage.setItem("IvrGUIDDetails",this._commonSer.encryptData(JSON.stringify(ivrGuid),SfaxEncryptionVector));
        }
        sessionStorage.clear();
        if (timeExpired) {
            localStorage.setItem("TimeOutSession", "true");
        }
        if(!sso)
        {
            window.close();
            window.close();
        }
        else
        {
            if(redirectUrl && this.isSafeRedirectUrl(redirectUrl)){
                window.close();
                window.onbeforeunload = null;
                window.location.href = redirectUrl;
            } else{
                this._router.navigate(["/login"]);
            }
        }
    }

    private decreaseRequests() {
        this.totalRequests--;
        if (this.totalRequests === 0 || this.totalRequests < 0) {
            this.hideLoader();
        }
    }

    private startLoader(): void {
        this._loadrServ.display(true);
    }

    private hideLoader(): void {
        this._loadrServ.display(false);
    }

    private showLoaderMsg(msg): void {
        this._loadrServ.addMessage(msg);
    }

    private removeLoaderMsg(): void {
        this._loadrServ.addMessage(null);
    }

    checkAndGetToken(req: HttpRequest<any>) {
        let access_token = this._userServ.getAccessToken();
        let overideObj = this._commonSer.getOverrideObj();
        if (overideObj.overrideEndpoint && overideObj.overrideToken &&
            overideObj.overrideEndpoint.split("_")[0].toLowerCase() === req.method.toLowerCase() &&
            this.checkIfUrlMatched(constant[overideObj.overrideEndpoint], req.url)) {
            access_token = overideObj.overrideToken;
            this._commonSer.resetOverrideObj();
        }
        return access_token;
    }

    checkAndGetToken2(req: HttpRequest<any>) {
        this.override = false;
        let access_token = this._userServ.getAccessToken();
        let overideObj = this._commonSer.getOverrideObj();
        if (overideObj && overideObj.overrideEndpoint && Array.isArray(overideObj.overrideEndpoint)) {
            let endPointToRemove;
            overideObj.overrideEndpoint.forEach(singleEndpoint => {
                if (singleEndpoint && overideObj.overrideToken &&
                    singleEndpoint.split("_")[0].toLowerCase() === req.method.toLowerCase() &&
                    this.checkIfUrlMatched(constant[singleEndpoint], req.url)) {
                    access_token = overideObj.overrideToken;
                    endPointToRemove = singleEndpoint;
                    this.override = true;
                }
            });
        } else {
            if (overideObj.overrideEndpoint && overideObj.overrideToken &&
                overideObj.overrideEndpoint.split("_")[0].toLowerCase() === req.method.toLowerCase() &&
                this.checkIfUrlMatched(constant[overideObj.overrideEndpoint], req.url)) {
                access_token = overideObj.overrideToken;
                this.override = true;
            }
        }
        return access_token;
    }

    checkAndGetUserid(req) {
        return this.getIdFromTokenOrOverride(req, "UserId");
    }
    
    checkAndGetTechnicianid(req) {
        return this.getIdFromTokenOrOverride(req, "TechnicianId");
    }
    
    checkAndGetPharmacistid(req) {
        return this.getIdFromTokenOrOverride(req, "PharmacistId");
    }
    
    getIdFromTokenOrOverride(req, tokenKey) {
        let id = this._userServ.getToken(tokenKey);
        const overrideObj = this._commonSer.getOverrideObj();
        if (overrideObj && overrideObj.overrideEndpoint && Array.isArray(overrideObj.overrideEndpoint)) {
            let endPointToRemove;
            overrideObj.overrideEndpoint.forEach(singleEndpoint => {
                if (singleEndpoint && singleEndpoint.split("_")[0].toLowerCase() === req.method.toLowerCase() &&
                    this.checkIfUrlMatched(constant[singleEndpoint], req.url)) {
                    id = overrideObj[tokenKey];
                    if (tokenKey == "UserId")
                        this._commonSer.resetOverrideObj();
                }
            });
            if (endPointToRemove) {
                this._commonSer.removeEndpoint(endPointToRemove);
            }
        } else {
            if (overrideObj.overrideEndpoint && overrideObj.overrideEndpoint.split("_")[0].toLowerCase() === req.method.toLowerCase() && this.checkIfUrlMatched(constant[overrideObj.overrideEndpoint], req.url)) {
                id = overrideObj[tokenKey];
                if (tokenKey == "UserId")
                    this._commonSer.resetOverrideObj();
            }
        }
        return id;
    }

    checkIfUrlMatched(constEndPoint, reqUrl) {
        if (reqUrl && constEndPoint && reqUrl.indexOf(constEndPoint.split("{")[0]) >= 0 ) {
            let reqUrlArr = reqUrl.split("/");
            let endPointArr = constEndPoint.split("/");
            if (reqUrlArr.length === endPointArr.length) {
                endPointArr.forEach((segment, i ) => {
                    if (!(segment[0] === "{" && segment[segment.length - 1] === "}") && segment !== reqUrlArr[i]) {
                        return false;
                    }
                });
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    checkAndSetTimeout(reqUrl?) {
        if (!this.endTime) {
            this.endTime = this._commonSer.DecryptData(localStorage.getItem("TimeOut"));
        }
        // if (this._commonSer.DecryptData(sessionStorage.getItem("ExpireTime")) &&
        if (!reqUrl || (reqUrl && reqUrl.indexOf("version.json?") === -1) ) {
            const timeOutObserv = this._cmnStr.timeOutSession$["source"]["value"];
            if (!timeOutObserv) {
                const expireTime = sessionStorage.getItem("ExpireTime");
                if (expireTime) {
                    const decryptedExpireTime = this._commonSer.DecryptData(expireTime);
                    if (moment().isAfter(moment(decryptedExpireTime))) {
                        // Logout logic
                        localStorage.setItem("NOEVENT", this._commonSer.encryptData("true"));
                        this._userServ.notifyIdleTimedOut("logout");
                        if (reqUrl && reqUrl.indexOf("Account/LogOut") > -1) {
                            return false;
                        } else {
                            return true;
                        }
                    } else if(localStorage.getItem("userLogged") && this.endTime) {
                        this.increaseExpireTime();
                    }
                }else if(localStorage.getItem("userLogged") && this.endTime) {
                        this.increaseExpireTime();
                }
            }
             else if(localStorage.getItem("userLogged") && this.endTime) {
                this.increaseExpireTime();
            }
            return false;
        }
    }

    increaseExpireTime() {
        let value;
        if (typeof localStorage !== 'undefined' && localStorage.getItem("userLogged") !== null) {
            value = window.location.href;
        } else {
            value = this._location.path();
        }
        localStorage.setItem("NOEVENT", this._commonSer.encryptData("false"));
        if(value && (!value.includes("/login") && !value.includes("redirectsso")) && (!sessionStorage.getItem("ExpireTime") || (sessionStorage.getItem("ExpireTime") && !this._commonSer.DecryptData(sessionStorage.getItem("ExpireTime"))))) {
            this._userServ.notifyIdleTimedOut("logout");
        } else {
            sessionStorage.setItem("ExpireTime", this._commonSer.encryptData(moment().add(this.endTime * 60, 'seconds').toISOString()));
        }
        
    }
}